import { AcademyDetailsLayout } from "@features/layout/academyDetails";

export const AcademyDetailsPage = () => {
  return <AcademyDetailsLayout />;
};
